import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { OfbizForm } from '@urbannex/ofbiz-forms';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LookUpDialogService } from '../look-up-dialog.service';

@Component({
  selector: 'ubs-lookup-dialog-form-container',
  templateUrl: './lookup-dialog-form-container.component.html',
  styleUrls: ['./lookup-dialog-form-container.component.scss']
})
export class LookupDialogFormContainerComponent implements OnInit,OnDestroy {
  @Input() ofbizForm:OfbizForm;
  @Input() title:string;
  viewMode:string = "collapsible";
  isLookup:boolean = true;

  selectedValueSubscription:Subscription;
  private destroy$ = new Subject<void>();

  @Output() setLookupSelectedValue = new EventEmitter();

  constructor(private lookupDialogService:LookUpDialogService) { }

  ngOnInit(): void {
    this.selectedValueSubscription = this.lookupDialogService.getSelectedRow()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      console.log({TrackLookupSelectedValue:data});
      this.setLookupSelectedValue.emit(data);
    })
  }

  setFormData(formData:any):void{
    this.lookupDialogService.setFindParameters(formData)
    //console.log({LookupDialogFormContainerComponent:formData})
  }

  ngOnDestroy(): void {
    this.destroy$.unsubscribe();
  }

}
